import React from 'react';
import { BankScrapingAU } from 'components/Credit24/LoanApplication/BankScrapingAU';
import { useBankScrapingAU } from './hooks';
import { BankScrapingError } from './BankScrapingError';

export const BankScrapingAUContainer = () => {
  const {
    isError,
    bankScrapingResult,
    iFrameUrl,
    retryKey,
    isIframeLoaded,
    handleIframeLoad,
    handleIframeError,
    handleRetry,
  } = useBankScrapingAU();

  return (
    isError ? (
      <BankScrapingError {...{ bankScrapingResult, handleRetry }} />
    ) : (
      <BankScrapingAU
        key={retryKey}
        iFrameUrl={iFrameUrl}
        isIframeLoaded={isIframeLoaded}
        onIframeLoad={handleIframeLoad}
        onIframeError={handleIframeError}
      />
    )
  );
};
